module.exports = __webpack_public_path__ + "img/r3.43a6187f.png";